import { Card } from 'antd';
import { Helmet } from 'react-helmet';

import { DashboardCharts } from '@/components';

export const StatisticsPage = () => {
    return (
        <>
            <Helmet>
                <title>Статистика</title>
            </Helmet>
            <Card title="Статистика">
                <DashboardCharts />
            </Card>
        </>
    );
};
